import { render, staticRenderFns } from "./BusinessImageUpdate.vue?vue&type=template&id=bd0916b2&"
import script from "./BusinessImageUpdate.vue?vue&type=script&lang=js&"
export * from "./BusinessImageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports